
















import { Component, Vue, Prop } from 'vue-property-decorator';
import avatar_initials from '../utils/avatar-initials';
import { User } from '../interfaces/models/user';

@Component
export default class AssetCardTaskAssign extends Vue {
  @Prop({ type: Array }) assignments!: User.BaseInfos[];
  @Prop({
    type: Object,
    default: {
      to_do: 0,
      needs_approval: 0
    }
  })
  counts!: {
    to_do: number;
    needs_approval: number;
  };
  @Prop({ type: Number }) approvalCount!: string;
}
